package settings.syndrome.components


import antd.checkbox.checkboxGroup
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.message.message
import antd.modal.modal
import antd.radio.radioButton
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.option
import antd.select.select
import com.jingfangpai.api.clients.SyndromeApiClient
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.Syndrome
import com.jingfangpai.common.orm.mapping.SyndromeIndication
import com.jingfangpai.common.orm.mapping.enums.*
import external.toJsObject
import kotlinext.js.Object
import react.*
import react.dom.div
import kotlinx.browser.window

external interface SyndromeEditModalProps : RProps {
    var isVisible:Boolean
    var changeVisibility:(Boolean)->Unit
    var syndrome: Syndrome
    var save:(syndrome:com.jingfangpai.common.orm.mapping.Syndrome, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Syndrome>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
    var onSaved:()->Unit
}

data class SyndromeEditModalContextData(var placeHolderFunction: (param: String) -> Unit)

val SyndromeEditModal = functionalComponent<SyndromeEditModalProps> { props ->

    val (editingSyndrome,setEditingSyndrome) = useState(props.syndrome)
    val (groupNames, setGroupNames) = useState(arrayOf<String>())
    val (loadingGroupNames, setLoadingGroupNames) = useState(false)

    useEffectOnce { 
        // Load existing group names from API
        setLoadingGroupNames(true)
        SyndromeApiClient.getGroupNames({ resp ->
            if(resp.ok()) {
                setGroupNames(resp.data!!)
            }
            setLoadingGroupNames(false)
        }, { error ->
            console.error(error)
            setLoadingGroupNames(false)
        })
    }

    useEffect(props.syndrome){
        setEditingSyndrome(props.syndrome)
    }

    div("SyndromeEditModal") {
        modal {
            attrs{
                style = kotlinext.js.js {
                    width = "832px"
                }
                visible = props.isVisible
                onCancel = {
                    props.changeVisibility(false)
                }
                onOk = {
                    props.save(editingSyndrome,{resp->
                        if(resp.ok()){
                            props.changeVisibility(false)
                            props.onSaved()
                        }else{
                            message.error("出错了，${resp.message?:"未知错误"}")
                        }
                    },{
                        console.log(it)
                        message.error("出错了，${it.message?:"未知错误"}")
                    })
                }
                cancelText = "取消"
                okText = "保存"
            }
            form{
                attrs{
                    layout = "horizontal"
                }
                formItem {
                    attrs{
                        label = "名称"
                    }
                    input {
                        attrs {
                            value = editingSyndrome?.name?:""
                            placeholder = "请填写名称"
                            onChange = {event: dynamic ->
                                val entity = Object.assign(Syndrome(),editingSyndrome)
                                entity.name = event.target.value as String
                                setEditingSyndrome(entity)
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "组名"
                    }
                    select<String, SelectComponent<String>> {
                        attrs {
                            showSearch = true
                            style = kotlinext.js.js { width = "100%" }
                            value = editingSyndrome?.groupName ?: ""
                            placeholder = "请选择或输入组名"
                            mode = "tags"
                            onChange = { value: dynamic, option: dynamic ->
                                val entity = Object.assign(Syndrome(), editingSyndrome)
                                // In tags mode, value is an array. Get the last non-empty element
                                val groupName = if (js("Array.isArray")(value)) {
                                    // Filter out undefined/null and get the last valid value
                                    val validValues = js("Array.from(value).filter(function(v) { return v != null && v !== undefined && v !== ''; })")
                                    if (validValues.length > 0) {
                                        (validValues[validValues.length - 1] as? String) ?: ""
                                    } else {
                                        ""
                                    }
                                } else {
                                    (value as? String) ?: ""
                                }
                                entity.groupName = groupName
                                setEditingSyndrome(entity)
                            }
                        }
                        // Add existing group names as options
                        groupNames.forEach { groupName ->
                            option {
                                attrs.value = groupName
                                +groupName
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "排序"
                    }

                    radioGroup{
                        attrs{
                            value = "${editingSyndrome.weight?:""}"
                            onChange = { event:dynamic ->
                                val entity = Object.assign(Syndrome(),editingSyndrome)
                                entity.weight = (event.target.value as String).toInt()
                                setEditingSyndrome(entity)
                            }
                        }
                        IntRange(1,80).forEach { idx ->
                            radioButton {
                                attrs.value = "${idx}"
                                +"${idx}"
                            }
                        }
                    }
                }
                formItem {
                    attrs{
                        label = "病证描述"
                    }
                    textArea {
                        attrs {
                            value = editingSyndrome.description ?:""
                            rows = 10
                            onChange = {event: dynamic ->
                                val entity = Object.assign(Syndrome(),editingSyndrome)
                                entity.description = event.target.value as String
                                setEditingSyndrome(entity)
                            }
                        }
                    }
                }
            }
        }
    }
}
